import React from 'react';
import { useIntl } from 'react-intl';
import { Controller, useFormContext } from 'react-hook-form';

const RewashCauses = () => {
  const intl = useIntl();
  const { control } = useFormContext();
  return (
    <div>
      <div className="form-group row" style={{ marginBottom: '0' }}>
        <div className="col-sm-12">
          <label className="detail-info-label">{intl.formatMessage({ id: 'rewashCauses' })}</label>
        </div>
      </div>
      <div className="form-group row">
        <div className="col-sm-6">
          <div className="form-check">
            <label className="form-check-label">
              <Controller
                name="incidentDetails.needsRewash.dirtyWheels"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <input
                    id="dirtyWheels"
                    className="form-check-input"
                    type="checkbox"
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                  />
                )}
              />{' '}
              {intl.formatMessage({ id: 'dirtyWheels' })}
            </label>
          </div>
          <div className="form-check">
            <label className="form-check-label">
              <Controller
                name="incidentDetails.needsRewash.dirtyRockerPanel"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <input
                    id="dirtyRockerPanel"
                    className="form-check-input"
                    type="checkbox"
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                  />
                )}
              />{' '}
              {intl.formatMessage({ id: 'dirtyRockerPanel' })}
            </label>
          </div>
          <div className="form-check">
            <label className="form-check-label">
              <Controller
                name="incidentDetails.needsRewash.dirtyBackend"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <input
                    id="dirtyBackend"
                    className="form-check-input"
                    type="checkbox"
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                  />
                )}
              />{' '}
              {intl.formatMessage({ id: 'dirtyBackend' })}
            </label>
          </div>
          <div className="form-check">
            <label className="form-check-label">
              <Controller
                name="incidentDetails.needsRewash.other"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <input
                    id="other"
                    className="form-check-input"
                    type="checkbox"
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                  />
                )}
              />{' '}
              {intl.formatMessage({ id: 'other' })}
            </label>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-check">
            <label className="form-check-label">
              <Controller
                name="incidentDetails.needsRewash.serviceFailure"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <input
                    id="serviceFailure"
                    className="form-check-input"
                    type="checkbox"
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                  />
                )}
              />{' '}
              {intl.formatMessage({ id: 'serviceFailure' })}
            </label>
          </div>
          <div className="form-check">
            <label className="form-check-label">
              <Controller
                name="incidentDetails.needsRewash.missedSpots"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <input
                    id="missedSpots"
                    className="form-check-input"
                    type="checkbox"
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                  />
                )}
              />{' '}
              {intl.formatMessage({ id: 'missedSpots' })}
            </label>
          </div>
          <div className="form-check">
            <label className="form-check-label">
              <Controller
                name="incidentDetails.needsRewash.bugs"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <input
                    id="bugs"
                    className="form-check-input"
                    type="checkbox"
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                  />
                )}
              />{' '}
              {intl.formatMessage({ id: 'bugs' })}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RewashCauses;
